import { Link } from "react-router";
import type { Route } from "./+types/articles";
import Shell from "../components/Shell";
import { listArticles, coverUrl, type ArticleListItem } from "../lib/api";
import { faDate } from "../lib/format";

export function meta() {
  return [
    { title: "نوشته‌ها | گازار" },
    { name: "description", content: "همه‌ی نوشته‌های فارسی." },
  ];
}

export async function loader() {
  try {
    const { items, total } = await listArticles(200);
    return { articles: items, total };
  } catch {
    return { articles: [] as ArticleListItem[], total: 0 };
  }
}

export default function Articles({ loaderData }: Route.ComponentProps) {
  const { articles } = loaderData;
  return (
    <Shell>
      <div className="bg-white">
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <h1 className="mb-8 text-3xl font-bold">نوشته‌ها</h1>
        {articles.length === 0 ? (
          <p className="text-ink-soft">هنوز نوشته‌ای منتشر نشده است.</p>
        ) : (
          <ul className="space-y-6">
            {articles.map((a) => {
              // Computed once rather than called in both the guard and the src.
              const cover = coverUrl(a.image);
              return (
                <li key={a.id} className="border-b border-border-subtle pb-6 last:border-0">
                  {/* A thumbnail beside the text rather than a banner above it:
                      this route is the full back-catalogue, so it has to stay
                      scannable as it grows. The page is RTL, so the image being
                      first in source order puts it on the leading (right) edge. */}
                  <Link
                    to={`/maghale/${a.slug}`}
                    className="flex flex-col gap-4 sm:flex-row sm:items-start"
                  >
                    {cover ? (
                      <img
                        src={cover}
                        alt=""
                        loading="lazy"
                        width={1376}
                        height={768}
                        className="aspect-video w-full rounded-smooth border border-border-subtle object-cover sm:w-52 sm:shrink-0"
                      />
                    ) : null}
                    {/* min-w-0 so a long Persian title wraps instead of forcing
                        the flex row wider than its container. */}
                    <div className="min-w-0 flex-1">
                      <h2 className="mb-1 text-xl font-bold text-brand-navy">{a.title}</h2>
                      {a.description ? (
                        <p className="mb-2 leading-[1.9] text-ink-soft">{a.description}</p>
                      ) : null}
                      <time className="text-sm text-ink-muted">{faDate(a.publishedAt)}</time>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </div>
      </div>
    </Shell>
  );
}
